<script>
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import 'vue-cal/dist/i18n/pl.js'

export default {
  extends: VueCal,
  props: {
    events: { type: Array, required: false },
    disableViews: {
      type: Array,
      default: () => ['years', 'year', 'month', 'day']
    },
    timeFrom: {
      type: Number,
      default: 6 * 60
    },
    timeTo: {
      type: Number,
      default: 22 * 60
    },
    timeCellHeight: {
      type: Number,
      default: 50
    },
    minDate: {
      type: Date,
      default: () => new Date()
    },
    hideViewSelector: {
      type: Boolean,
      default: true
    },
    timeStep: {
      type: Number,
      default: 60
    },
    locale: {
      type: String,
      default: 'pl'
    }
  },
  components: {
    VueCal
  }
}
</script>

<style lang="scss">
.vuecal {
  box-shadow: none;

  &__body {
    box-shadow: inset 0 0 0 1px rgba(black, 0.08);
    border-radius: 12px;
  }

  &__title-bar {
    height: 48px;
    padding: 8px 0;
    background: transparent;
    font-size: 1em;
    justify-content: center;

    opacity: 0.7;
  }

  &__title {
    white-space: nowrap;
  }

  &__title[grow] {
    width: auto;
    flex: initial;
  }

  &--view-with-time &__weekdays-headings,
  &--week-numbers &__weekdays-headings {
    padding-left: 4em;
  }

  &__time-column {
    width: 4em;

    .vuecal__time-cell {
      text-align: center;
    }

    .label {
      display: inline-block;
      padding-top: 4px;
    }
  }

  &__event {
    border-radius: 6px;
    padding: 3px 2px 2px 3px;
    background-color: transparent;
    min-height: 38px;

    &:hover {
      z-index: 1;
    }

    &--focus {
      box-shadow: none !important;
    }
  }

  &__no-event {
    display: none;
  }

  &__cell {
    &--selected {
      background-color: inherit;
    }

    &--before-min {
      background: #f5f5f5;
    }

    &--current,
    &--today {
      background-color: transparent;
    }

    &--before-min {
      background: rgba(black, 0.03);
    }
  }

  &__flex &__weekdays-headings {
    margin-top: 16px;
    border: 0;
    margin-bottom: 0;
  }

  &__heading {
    color: rgba(#0b0204, 0.55);

    &.today {
      color: #0b0204;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        border-radius: 2px 2px 0 0;
        background-color: #0b0204;
      }
    }
  }
}
</style>
